export interface IUserServiceState {
    serviceCategories?: IServiceCategory[];
    loadingServices: boolean;
    isAddWrittenTimestampLoading: boolean;
}

export const REQUEST_USER_SEVICES = "REQUEST_USER_SEVICES";
export const RECEIVE_USER_SEVICES = "RECEIVE_USER_SEVICES";

export const ADD_WRITTEN_INSTRUCTION_TIMESTAMP = "ADD_WRITTEN_INSTRUCTION_TIMESTAMP";
export const WRITTEN_INSTRUCTION_TIMESTAMP_LOADER = "WRITTEN_INSTRUCTION_TIMESTAMP_LOADER";

export interface IRequestUserService {
    type: typeof REQUEST_USER_SEVICES;
}

export interface IReceiveUserService {
    type: typeof RECEIVE_USER_SEVICES;
    serviceCategories?: IServiceCategory[];
}

export interface ISetWrittenInstructionLoader {
    type: typeof WRITTEN_INSTRUCTION_TIMESTAMP_LOADER;
    isAddWrittenTimestampLoading: boolean;
}

export interface ISetWrittenInstructionTimestamp {
    type: typeof ADD_WRITTEN_INSTRUCTION_TIMESTAMP;
    timestamp?: string;
}

export type UserServiceTypes = IRequestUserService | IReceiveUserService;
export type WrittenInstructionTimestampTypes = ISetWrittenInstructionLoader | ISetWrittenInstructionTimestamp;

export interface IServiceCategory {
    categoryName?: string;
    upgradableText?: string;
    isUpgradable?: boolean;
    services?: IService[];
}

export interface IService {
    displayName?: string;
    activeText?: string;
    link?: string;
    category?: string;
    isLink?: boolean;
    serviceCode?: string;
}
